import { MESSAGE_CENTER as type } from '../actions/messageCenterTypes';

const initialState = {
    getMessageTypesLoading: false,
    getMessageTypes: [],
    getMessageTypesError: false,
    getRecipientGroupLoading: false,
    getRecipientGroup: [],
    getRecipientGroupError: false,
    getDisableOptionLoading: false,
    getDisableOption: [],
    getDisableOptionError: false,
    getRecipientsAllLoading: false,
    getRecipientsAll: [],
    getRecipientsAllError: false,
    getMessagesGeneralLoading: false,
    getMessagesGeneral: [],
    getMessagesGeneralError: false,
    getMessagesHistoryLoading: false,
    getMessagesHistory: [],
    getMessagesHistoryError: false,
    getDraftsLoading: false,
    getDrafts: [],
    getDraftsError: false,
}

export default function messageCenterReducer(state = initialState, action){
    switch(action.type){
        case type.GET_DRAFTS:
            return {
                ...state,
                getDraftsLoading: true
            }
        case type.GET_DRAFTS_SUCCESS:
            return {
                ...state,
                getDrafts: action.payload, 
                getDraftsLoading: false      
            }
        case type.GET_DRAFTS_FAIL:
            return {
                ...state,
                getDrafts: initialState.getDrafts,
                getDraftsLoading: false,
                getDraftsError: action.payload
            }
        case type.GET_MESSAGES_GENERAL_HISTORY:
            return {
                ...state,
                getMessagesHistoryLoading: true
            }
        case type.GET_MESSAGES_GENERAL_HISTORY_SUCCESS:
            return {
                ...state,
                getMessagesHistory: action.payload, 
                getMessagesHistoryLoading: false      
            }
        case type.GET_MESSAGES_GENERAL_HISTORY_FAIL:
            return {
                ...state,
                getMessagesHistory: initialState.getMessagesHistory,
                getMessagesHistoryLoading: false,
                getMessagesHistoryError: action.payload
            }
        case type.GET_MESSAGES_GENERAL:
            return {
                ...state,
                getMessagesGeneralLoading: true
            }
        case type.GET_MESSAGES_GENERAL_SUCCESS:
            return {
                ...state,
                getMessagesGeneral: action.payload, 
                getMessagesGeneralLoading: false      
            }
        case type.GET_MESSAGES_GENERAL_FAIL:
            return {
                ...state,
                getMessagesGeneral: initialState.getMessagesGeneral,
                getMessagesGeneralLoading: false,
                getMessagesGeneralError: action.payload
            }
        case type.GET_RECIPIENTS_ALL:
            return {
                ...state,
                getRecipientsAllLoading: true
            }
        case type.GET_RECIPIENTS_ALL_SUCCESS:
            return {
                ...state,
                getRecipientsAll: action.payload, 
                getRecipientsAllLoading: false      
            }
        case type.GET_RECIPIENTS_ALL_FAIL:
            return {
                ...state,
                getRecipientsAllLoading: false,
                getRecipientsAllError: action.payload
            }
        case type.GET_DISABLE_OPTION:
            return {
                ...state,
                getDisableOptionLoading: true
            }
        case type.GET_DISABLE_OPTION_SUCCESS:
            return {
                ...state,
                getDisableOption: action.payload, 
                getDisableOptionLoading: false      
            }
        case type.GET_DISABLE_OPTION_FAIL:
            return {
                ...state,
                getDisableOptionLoading: false,
                getDisableOptionError: action.payload
            }
        case type.GET_RECIPIENT_GROUP:
            return {
                ...state,
                getRecipientGroupLoading: true
            }
        case type.GET_RECIPIENT_GROUP_SUCCESS:
            return {
                ...state,
                getRecipientGroup: action.payload, 
                getRecipientGroupLoading: false      
            }
        case type.GET_RECIPIENT_GROUP_FAIL:
            return {
                ...state,
                getMessageTypesLoading: false,
                getMessageTypesError: action.payload
            }
        case type.GET_MESSAGE_TYPES:
            return {
                ...state,
                getMessageTypesLoading: true
            }
        case type.GET_MESSAGE_TYPES_SUCCESS:
            return {
                ...state,
                getMessageTypes: action.payload, 
                getMessageTypesLoading: false      
            }
        case type.GET_MESSAGE_TYPES_FAIL:
            return {
                ...state,
                getMessageTypesLoading: false,
                getMessageTypesError: action.payload
            }
        default:
            return state;
    }
}